export { handleMinimumFractionDigits, FormattedPrice } from '../src/FormattedPrice';
